module.exports = __webpack_public_path__ + "static/media/budget.svg.433a5575.png";